import { useTw } from '../Styles'
import { DocumentIcon } from '@heroicons/react/outline'

const colors: Record<string, string> = {
  pdf: '#EF4444',
  xlt: '#10B981',
  ppt: '#FBBF24',
  doc: '#3B82F6',
  docx: '#3B82F6',
}

type Props = { ext: string; url?: string; filename: string }

export function AttachmentIcon({ ext, url, filename }: Props) {
  const tw = useTw()
  const color = colors[ext] || '#C2BFCD'

  if (url) {
    return (
      <img
        src={url}
        alt={filename}
        className={tw`rounded h-8 w-8 mr-3 self-center object-cover`}
      />
    )
  }

  return (
    <div
      style={{ color }}
      className={tw`relative flex h-full items-center justify-center`}
    >
      <DocumentIcon className={tw`h-12 w-12`} />
      <span
        style={{ fontSize: 9 }}
        className={tw`absolute uppercase select-none mt-0.5`}
      >
        {ext}
      </span>
    </div>
  )
}

export function SmallAttachmentIcon({ ext }: { ext: string }) {
  const tw = useTw()
  const color = colors[ext] || '#C2BFCD'

  return (
    <div
      style={{ color }}
      className={tw`relative flex h-full items-center justify-center`}
    >
      <DocumentIcon className={tw`h-4 w-4`} />
      <span
        style={{ fontSize: 9 }}
        className={tw`absolute uppercase select-none`}
      >
        {ext}
      </span>
    </div>
  )
}
